<script>
  // src/Mapbox.svelte
  /*____________ Imports ____________*/
  // Mobile detection
  import UA from "ua-parser-js";
  const ua = new UA();
  let isMobile = ua.getResult().device["type"] == "mobile";

  import { getContext, onMount } from "svelte";
  import {
    Map,
    controls,
    Marker,
    Geocoder,
    contextKey,
  } from "@beyonk/svelte-mapbox";
  const { GeolocateControl, NavigationControl, ScaleControl } = controls;
  export let mapComponent;

  import MapScripting from "./MapScripting.svelte";
  import MapExpand from "./MapExpand.svelte";
  import CampusMarker from "./CampusMarker.svelte";

  /*____________ Variables ____________*/
  export let tour;
  export let expanded;
  export let zoom;
  export let showMarkers = false;
  export let mapLocationsVisible = false;
  const { scenes } = tour;

  $: if (expanded !== null) {
    mapComponent?.resize();
    showMarkers = expanded;
  }

  function debugRecentre(e) {
    console.log("event:", e.detail);
    console.log("center:", e.detail.center);
  }

  // Get map options based on device type
  function getMapOptions() {
    if (isMobile && tour?.mapbox?.mobile) {
      console.log("mobile options");
      return {
        pitch: tour?.mapbox?.mobile?.mapPitch ?? tour?.mapbox?.mapPitch,
        bearing: tour?.mapbox?.mobile?.mapBearing ?? tour?.mapbox?.mapBearing,
        center: tour?.mapbox?.mobile?.mapCenter ?? tour?.mapbox?.mapCenter,
        respectPrefersReducedMotion: true,
      };
    }
    return {
      pitch: tour?.mapbox?.mapPitch,
      bearing: tour?.mapbox?.mapBearing,
      center: tour?.mapbox?.mapCenter,
      respectPrefersReducedMotion: true,
    };
  }

  let interval;
  onMount(() => {
    interval = setInterval(() => {
      const container = document.querySelector('.mapboxgl-control-container');
      if (container) {
        const controls = container.querySelectorAll('button, a, input');
        controls.forEach(control => {
          control.tabIndex = -1;
          control.setAttribute('aria-hidden', 'true');
        });
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  });
</script>

<div class="map">
  <Map
    accessToken={tour?.mapbox?.mapboxAccessToken}
    style={tour?.mapbox?.mapboxStyleUrl}
    {zoom}
    bind:this={mapComponent}
    on:recentre={debugRecentre}
    options={getMapOptions()}
  >
    {#if isMobile}
      <!-- <NavigationControl position={'top-right'} options={{ visualizePitch: true }}  /> -->
      <GeolocateControl position={"top-right"} />
      <!-- <ScaleControl /> -->
    {/if}

    <MapScripting
      {tour}
      {expanded}
      bind:mapLocationsVisible
    />
  </Map>
</div>

<style>
  :global(.map canvas) {
    width: 100% !important;
    height: 100% !important;
  }

  :global(.mapboxgl-ctrl-top-right) {
    top: 65px !important;
    right: 18px !important;
  }
</style>
